import type { SVGProps } from 'react'

export function MailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  )
}

export function PhoneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  )
}

export function UserIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  )
}

/** Figma user-01 used in link_account graphic (15×16.67 artboard). */
export function LinkUserIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="15" height="17" viewBox="0 0 15.0001 16.6667" fill="none" aria-hidden="true" {...props}>
      <path
        d="M14.1667 15.8333C14.1667 14.6704 14.1667 14.0889 14.0232 13.6157C13.7 12.5504 12.8664 11.7167 11.801 11.3935C11.3279 11.25 10.7464 11.25 9.5834 11.25H5.41674C4.25377 11.25 3.67228 11.25 3.19912 11.3935C2.13378 11.7167 1.3001 12.5504 0.976936 13.6157C0.833403 14.0889 0.833403 14.6704 0.833403 15.8333M11.2501 4.58333C11.2501 6.6544 9.57114 8.33333 7.50007 8.33333C5.429 8.33333 3.75007 6.6544 3.75007 4.58333C3.75007 2.51227 5.429 0.833333 7.50007 0.833333C9.57114 0.833333 11.2501 2.51227 11.2501 4.58333Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function IdCardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <circle cx="8" cy="10" r="2" />
      <path d="M14 10h4" />
      <path d="M14 14h4" />
      <path d="M6 16c0-1.5 1.5-2 3-2s3 .5 3 2" />
    </svg>
  )
}

export function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  )
}

export function MapPinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  )
}

export function TaxIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  )
}

export function ShieldIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  )
}

export function BankIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  )
}

export function SwapIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M2.167 4.832 4.362 2.637a.833.833 0 0 1 1.179 0L7.5 4.832M8.5 11.165l2.195 2.196a.833.833 0 0 0 1.179 0l2.195-2.196M4.833 3.332v10.167M11.167 2.499v10.333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/** AccessTrade mark — Figma AT-Logo (link_account graphic). */
export function AtLogoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="12" viewBox="0 0 20 12.1429" fill="none" aria-hidden="true" {...props}>
      <path
        d="M19.999 12.143h-.258c-2.527-1.605-5.247-2.872-8.097-3.812 1.334-.729 2.656-1.32 4.258-1.9 1.452 1.7 2.796 3.58 4.097 5.712Z"
        fill="url(#at-logo-a)"
      />
      <path
        d="M16.914 5.607C14.903 3.453 12.699 1.637 10.086 0 5.968 3.094 2.882 6.621 0 11.763l.247-.011c4.602-3.199 10.248-5.385 16.667-6.145Z"
        fill="url(#at-logo-b)"
      />
      <defs>
        <linearGradient id="at-logo-a" x1="13.719" y1="7.321" x2="19.11" y2="13.857" gradientUnits="userSpaceOnUse">
          <stop stopColor="#942D1E" />
          <stop offset="0.454" stopColor="#EE6723" />
          <stop offset="1" stopColor="#FCB424" />
        </linearGradient>
        <linearGradient id="at-logo-b" x1="18.707" y1="0.792" x2="5.847" y2="5.947" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F7EC2C" />
          <stop offset="0.504" stopColor="#FCB424" />
          <stop offset="0.999" stopColor="#EE6723" />
        </linearGradient>
      </defs>
    </svg>
  )
}

/** Connector line (left of sync) — Figma Vector 600. */
export function LinkConnectorInIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="39" height="8" viewBox="0 0 42.5 8" fill="none" aria-hidden="true" {...props}>
      <path
        d="M34.5 4a4 4 0 1 0 8 0 4 4 0 0 0-8 0ZM0 4v.75h38.5V4v-.75H0V4Z"
        fill="#D9D9D9"
      />
      <path
        d="M34.5 4a4 4 0 1 0 8 0 4 4 0 0 0-8 0ZM0 4v.75h38.5V4v-.75H0V4Z"
        fill="url(#link-conn-in)"
      />
      <defs>
        <linearGradient id="link-conn-in" x1="2.25" y1="7" x2="28.25" y2="4" gradientUnits="userSpaceOnUse">
          <stop offset="0.232" stopColor="#3292FF" stopOpacity="0" />
          <stop offset="0.569" stopColor="#3292FF" />
          <stop offset="1" stopColor="#3292FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

/** Connector arrow (right of sync) — Figma Vector 601. */
export function LinkConnectorOutIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="39" height="11" viewBox="0 0 39.25 11.0459" fill="none" aria-hidden="true" {...props}>
      <path
        d="M.22 4.993a.75.75 0 0 0 0 1.06l4.773 4.773a.75.75 0 1 0 1.06-1.06L1.811 5.523 6.053 1.28A.75.75 0 1 0 4.993.22L.22 4.993ZM.75 5.523v.75h38.5v-.75v-.75H.75v.75Z"
        fill="#D9D9D9"
      />
      <path
        d="M.22 4.993a.75.75 0 0 0 0 1.06l4.773 4.773a.75.75 0 1 0 1.06-1.06L1.811 5.523 6.053 1.28A.75.75 0 1 0 4.993.22L.22 4.993ZM.75 5.523v.75h38.5v-.75v-.75H.75v.75Z"
        fill="url(#link-conn-out)"
      />
      <defs>
        <linearGradient id="link-conn-out" x1="3" y1="8.523" x2="29" y2="5.523" gradientUnits="userSpaceOnUse">
          <stop offset="0.232" stopColor="#3292FF" stopOpacity="0" />
          <stop offset="0.569" stopColor="#3292FF" />
          <stop offset="1" stopColor="#3292FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function WarningIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  )
}

export function SyncIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21.5 2v6h-6" />
      <path d="M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
    </svg>
  )
}

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  )
}

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}

/** Figma checkmark in link_account success sync button. */
export function LinkCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="11" height="10" viewBox="0 0 10.6668 9.77787" fill="none" aria-hidden="true" {...props}>
      <path
        d="M1.333 6.222 4.131 8.445 9.333 1.333"
        stroke="currentColor"
        strokeWidth="2.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
